import {TypeSnack} from './snack-bar.component';

export class Message {
  public message: string;
  public type: TypeSnack;
}
